import React, { Component, Suspense } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import axios from 'axios';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import './loader.scss';
import AuthComponent from './views/AuthComponent/AuthComponent';


import { backendUrlUser } from './BackendURL';

const loading = () => <div className='loader loader4'>
  <div>
    <div>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));
// const AuthComponent = React.lazy(() => import('./views/AuthComponent/AuthComponent'));

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged_userId: sessionStorage.getItem('userId'),
      logged_userName: sessionStorage.getItem('username'),
      logged_in: sessionStorage.getItem('logged_in'),
      loadLogin: true
    }
  }
  componentDidMount() {

    axios.get(backendUrlUser + '/authgetUser').then(res => {
      if (res.data === 'Verified') {
        this.setState({
          loadLogin: false
        })
      }
    }).catch(err => { })
  }

  render() {
    return (

      <Router>
        <Suspense fallback={loading()}>
          <Switch>

            {this.state.loadLogin ?
              <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
              : null}
            <AuthComponent>
              <Switch>
                <Route exact path={'/404'} name="Page 404" render={props => <Page404 {...props} />} />
                <Route exact path={'/500'} name="Page 500" render={props => <Page500 {...props} />} />
                <Route exact path={'/home'} render={props => <DefaultLayout {...props} />} />
                <Route path={'*'} name="Home" render={props => <DefaultLayout {...props} />} />
              </Switch>
            </AuthComponent>
            <Route path="*" name="Login Page" render={props => <Login {...props} />} />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

export default App;
